import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../assets/Icons/index.js";
import BalanceSummary from "../../components/_utils/CommonBalanceSummary/index.jsx";
import PrimaryWithIconButton from "../../components/_utils/CommonButtons/PrimaryWithIconButton/index.jsx";
import SmallAlertPopup from "../../components/_utils/CommonPopups/CommonAlertPopup";
import CommonToast from "../../components/_utils/CommonToast/index.jsx";
import MultiEntityBanner from "../../components/_utils/MultiEntityBanner";
import SVGComponent from "../../components/_utils/SVGComponent/index.jsx";
import HolidayCard from "../../components/HomeDashboard/HolidayCard/index.jsx";
import {
  beneCategories,
  beneViewAllAcc,
  unAssignCategories,
} from "../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import { beneTxnViewAllAcc } from "../../redux/features/beneficiary/beneTxnViewAccData/beneTxnViewAccData";
import { getHolidays } from "../../redux/features/date/date";
import { setHideBreadCrumb } from "../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { toggleCalendar } from "../../redux/features/HomeDashboard/homeDashCalender";
import { ViewAllAccountInternal } from "../../redux/features/InternalAccount/ViewAllAccountInternal.js";
import {
  internalTxnViewAll,
  resetInternalTxnViewAll,
} from "../../redux/features/internalTransaction/internalTransactionViewAll";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import { setshowsuccestoast } from "../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import { reminderTxnView } from "../../redux/features/reminderTransaction";
import { toast_position } from "../../redux/features/Settings/Authorization";
import {
  errorcode,
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../utils/configurationProvider.js";
import "./index.css";
import MessagePanel from "./MessagePanel/index.jsx";

const HomeDashboard = () => {
  // const [showBanner, setShowBanner] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const services = useSelector((state) => state.refreshToken.services);

  const [alertCount, setAlertCount] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  const [currentPage, setCurrentPage] = useState(
    GlobalConfiguration.lengthCheckOne,
  );
  const [currentSlide, setCurrentSlide] = useState(
    GlobalConfiguration.lengthCheckZero,
  );

  const [activeLabel, setActiveLabel] = useState(null);

  const [openTxnSlider, setOpenTxnSlider] = useState(null);
  const [isCalendarOpen, setIsCalendarOpen] = useState(null);

  const [hasFetchedCount, setHasFetchedCount] = useState(false);
  const [beneAccountsCount, setBeneAccountsCount] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  const [txnCountLoading, setTxnCountLoading] = useState(false);
  const [openMessagePanel, setOpenMessagePanel] = useState(null);
  const [openAccountSlider, setOpenAccountSlider] = useState(null);
  const [accountCountLoading, setAccountCountLoading] = useState(false);
  const [filteredBeneAccountsCount, setFilteredBeneAccountsCount] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  const [reimbursementAccountsCount, setReimbursementAccountsCount] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  const { ownerAccBalanceLoading, showSuccessToast } = useSelector(
    (state) => state.ownerAllVerification,
  );

  const { beneTxnViewAllAccData, beneTxnViewAllAccLoading } = useSelector(
    (state) => state.beneTxnViewAccData,
  );

  const { internalAccViewAllData, internalAccViewAllLoading } = useSelector(
    (state) => state?.ViewAllAccountInternal,
  );

  const { beneViewAllAccLoading, beneViewAllAccData } = useSelector(
    (state) => state.beneViewAccData,
  );

  const { internalTxnViewAllAccData, internalTxnViewAllAccLoading } =
    useSelector((state) => state?.internalTxnViewall);

  const categoriesData = useSelector(
    (state) => state.beneAllVerification.beneTransCategories.categories,
  );
  const reminderTxnViewLoading = useSelector(
    (state) => state.reminderTxnSlice.reminderTxnViewLoading,
  );
  const reminderTxnViewData = useSelector(
    (state) => state.reminderTxnSlice.reminderTxnViewData,
  );

  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);
  const entityHasBeenChanged = markerData;

  const holiday_list = useSelector((state) => state.date?.holiday_list);

  const beneficiaryAccountCount =
    beneViewAllAccData?.summary?.pending_accounts_count;

  const beneficiaryTxnCount =
    beneTxnViewAllAccData?.summary?.actionable_transaction_count;

  const internalAccountCount =
    internalAccViewAllData?.summary?.pending_accounts_count;

  const internalTxnCount =
    internalTxnViewAllAccData?.summary?.actionable_transaction_count;

  const holidays = useMemo(() => holiday_list?.holidays || [], [holiday_list]);

  const doPageInit = useCallback(async () => {
    dispatch(setHideBreadCrumb({ hide: true }));
    dispatch(getHolidays());

    try {
      const [reminderRes] = await Promise.allSettled([
        dispatch(reminderTxnView({ search_string: "" })),
        dispatch(
          beneTxnViewAllAcc({
            page_no: GlobalConfiguration.lengthCheckOne,
            page_item_count: PaginationConfiguration.paginationSmall,
          }),
        ),
        dispatch(
          beneViewAllAcc({
            page_no: GlobalConfiguration.lengthCheckOne,
            page_size: PaginationConfiguration.paginationSmall,
            approval_status: ["pending", "approved"],
          }),
        ),
        dispatch(
          internalTxnViewAll({
            page_no: GlobalConfiguration.lengthCheckOne,
            page_item_count: PaginationConfiguration.paginationSmall,
          }),
        ),
        dispatch(
          ViewAllAccountInternal({
            page_no: GlobalConfiguration.lengthCheckOne,
            page_size: PaginationConfiguration.paginationSmall,
            type: "internalAccount",
          }),
        ),
      ]);
    } catch (error) {
      setTimeout(() => {
        setAccountCountLoading(false);
        setTxnCountLoading(false);
      }, errorcode.errorFailed);
    }
  }, [dispatch, currentPage]);

  const doPageDestroy = useCallback(() => {
    dispatch(resetInternalTxnViewAll());
    dispatch(setHideBreadCrumb({ hide: false }));
  }, [dispatch]);

  // Mount/unmount
  useEffect(() => {
    dispatch(enableSwitcher());
    doPageInit();
    return () => {
      doPageDestroy();
      dispatch(disableSwitcher());
    };
  }, [dispatch, doPageInit, doPageDestroy]);

  // Refresh when entity changes
  useEffect(() => {
    if (entityHasBeenChanged) {
      doPageDestroy();
      doPageInit();
    }
  }, [entityHasBeenChanged, doPageInit, doPageDestroy]);

  useEffect(() => {
    dispatch(beneCategories());
  }, [dispatch]);

  const fetchAccountData = async (categories, currentPage) => {
    try {
      const response = await dispatch(
        unAssignCategories({
          page_no: currentPage,
          categoryName: categories,
        }),
      );

      const data = response?.payload;

      if (data?.status === true) {
        const accounts = data?.beneficiary_accounts || [];

        const beneficiaryOnlyCount = accounts.filter(
          (acc) => acc?.reimbursement_account !== "Y",
        ).length;

        if (currentPage === GlobalConfiguration.lengthCheckOne) {
          setFilteredBeneAccountsCount(beneficiaryOnlyCount);
        } else {
          setFilteredBeneAccountsCount((prev) => prev + beneficiaryOnlyCount);
        }
      } else {
        setFilteredBeneAccountsCount(GlobalConfiguration.lengthCheckZero);
      }
    } catch (error) {
      console.error("Beneficiary fetch failed", error);
      setFilteredBeneAccountsCount(GlobalConfiguration.lengthCheckZero);
    } finally {
      setHasFetchedCount(true);
    }
  };

  useEffect(() => {
    if (
      categoriesData.filter((category) => category?.active === "Y") &&
      categoriesData.filter((category) => category?.active === "Y").length >
        GlobalConfiguration.lengthCheckZero
    ) {
      setHasFetchedCount(false);

      const categoryNames = categoriesData
        .filter((category) => category?.active === "Y")
        .map((data) => data?.name);

      const categoryNamesStr = categoryNames.join(",");

      fetchAccountData(categoryNamesStr, currentPage);
    }
  }, [categoriesData, currentPage]);

  const handleInfoPanel = (label) => {
    if (activeLabel === label) {
      closePanel();
    } else {
      setActiveLabel(label);
      setOpenMessagePanel(true);
    }
  };

  const closePanel = () => {
    setOpenMessagePanel(false);
    setTimeout(
      () => setActiveLabel(null),
      PaginationConfiguration.paginationBig,
    );
  };

  // Alert handler - same as MessagePanel
  const handleBeneAcctView = useCallback(() => {
    if (filteredBeneAccountsCount === GlobalConfiguration.lengthCheckZero) {
      return;
    }

    if (
      services?.includes("Admin") ||
      (services?.includes("BVAccount") &&
        services?.includes("PLogin") &&
        services?.includes("BUAccount"))
    ) {
      navigate("/home/unassign_multi_categories");
      closePanel();
    } else {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "Admin, BVAccount, PLogin, BUAccount",
        },
      });
    }
  }, [filteredBeneAccountsCount, services, navigate]);

  const handleReimbursementCat = useCallback(() => {
    if (reimbursementAccountsCount === GlobalConfiguration.lengthCheckZero) {
      return;
    }

    if (
      services?.includes("Admin") ||
      (services?.includes("BVAccount") &&
        services?.includes("PLogin") &&
        services?.includes("BUAccount"))
    ) {
      navigate("/home/unassign_reimbursement_categories");
      closePanel();
    } else {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "Admin, BVAccount, PLogin, BUAccount",
        },
      });
    }
  }, [reimbursementAccountsCount, services, navigate]);

  // Alert content logic - same as MessagePanel
  const alertContentRaw = useMemo(
    () => [
      {
        mainText: `Unsafe beneficiary accounts found - ${filteredBeneAccountsCount.toLocaleString?.() ?? "00"}`,
        subText:
          "All categories are assigned to these accounts. Assigning all categories to a single account is highly unsafe.",
        viewAllFunct: handleBeneAcctView,
        show: filteredBeneAccountsCount > GlobalConfiguration.lengthCheckZero,
      },
    ],
    [filteredBeneAccountsCount, handleBeneAcctView],
  );

  const alertContent = useMemo(
    () => alertContentRaw.filter((item) => item.show),
    [alertContentRaw],
  );

  useEffect(() => {
    const actionableAlerts = alertContent.filter((item) => item.show);
    setAlertCount(actionableAlerts.length);
  }, [alertContent]);

  useEffect(() => {
    if (!ownerAccBalanceLoading) {
      setTimeout(() => {
        toast.dismiss();
        if (showSuccessToast) {
          setTimeout(() => {
            CommonToast({
              text: "Balance refreshed successfully.",
              icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
              variant: "var(--success)",
              btnProps: {
                isDisabled: false,
                enabledTextColor: "var(--text-primary)",
                enabledBgColor: "var(--primary-bg)",
              },
            });
            dispatch(setshowsuccestoast());
          }, PaginationConfiguration.paginationMid);
        }
      }, errorcode.errorFailed);
    }
  }, [ownerAccBalanceLoading]);

  const slides = Array.from(
    { length: GlobalConfiguration.lengthCheckZero },
    (_, i) => `Slide ${i + GlobalConfiguration.lengthCheckOne}`,
  );

  const nextSlide = () => {
    if (currentSlide < slides.length - GlobalConfiguration.lengthCheckOne) {
      setCurrentSlide(currentSlide + GlobalConfiguration.lengthCheckOne);
    }
  };

  const prevSlide = () => {
    if (currentSlide > GlobalConfiguration.lengthCheckZero) {
      setCurrentSlide(currentSlide - GlobalConfiguration.lengthCheckOne);
    }
  };

  const AddStatistics = () => {
    toast.info("This feature is not available at the moment.", toast_position);
  };

  const groupByMonth = (holidays) => {
    return holidays.reduce((acc, holiday) => {
      const date = new Date(holiday.date);
      const month = date.toLocaleString("default", { month: "long" });
      if (!acc[month]) {
        acc[month] = [];
      }
      acc[month].push(holiday);
      return acc;
    }, {});
  };

  const holidaysByMonth = groupByMonth(holidays);

  const date = useMemo(
    () =>
      holidays.length > GlobalConfiguration.lengthCheckZero
        ? new Date(holidays[GlobalConfiguration.lengthCheckZero].date).getDate()
        : null,
    [holidays],
  );

  const month = useMemo(
    () =>
      holidays.length > GlobalConfiguration.lengthCheckZero
        ? new Date(
            holidays[GlobalConfiguration.lengthCheckZero].date,
          ).toLocaleString("default", {
            month: "long",
          })
        : "",
    [holidays],
  );

  const ordinalize = (num) => {
    const numAsString = `${num}`;
    const unitsDigit = +numAsString.at(
      GlobalConfiguration.lengthCheckNegativeOne,
    );
    const tensDigit = +numAsString.at(-GlobalConfiguration.lengthCheckTwo);

    let suffix = "th";

    if (tensDigit === GlobalConfiguration.lengthCheckOne)
      return numAsString + suffix;

    switch (unitsDigit) {
      case 1:
        suffix = "st";
        break;
      case 2:
        suffix = "nd";
        break;
      case 3:
        suffix = "rd";
        break;
      default:
        suffix = "th";
    }

    return numAsString + suffix;
  };

  const employee = JSON.parse(sessionStorage.getItem("response"))?.employees;
  const canConciergeLogin = employee?.can_concierge_login === "Y";

  let pullTabIsSupressed =
    JSON.parse(sessionStorage.getItem("suppressPullTab")) ?? false;

  const [bannerDismissed, setBannerDismissed] = useState(() => {
    const stored = sessionStorage.getItem("bannerDismissed");
    return stored ? JSON.parse(stored) : false;
  });

  const subEntitySelected =
    sessionStorage.getItem("subEntitySelected") === "true";

  const showBanner =
    canConciergeLogin &&
    pullTabIsSupressed &&
    !bannerDismissed &&
    !subEntitySelected;

  const DataArray = [
    {
      headerName: "Unsafe beneficiary accounts found",
      subtext:
        "All categories are assigned to these accounts. Assigning all categories to a single account is highly unsafe.",
      btnText: "View all",
      count: filteredBeneAccountsCount.toLocaleString(),
      isDisabled:
        filteredBeneAccountsCount === GlobalConfiguration.lengthCheckZero
          ? true
          : false,
      handleFunction: () => {
        handleBeneAcctView();
      },
    },
    // {
    //   headerName: "Unsafe reimbursement accounts found",
    //   subtext:
    //     "All categories are assigned to these accounts. Assigning all categories to a single account is highly unsafe.",
    //   count: reimbursementAccountsCount?.toLocaleString?.() ?? "0",
    //   btnText: "View all",
    //   isDisabled:
    //     reimbursementAccountsCount === GlobalConfiguration.lengthCheckZero
    //       ? true
    //       : false,

    //   handleFunction: () => {
    //     handleReimbursementCat();
    //   },
    // },
  ];

  const currentMonth = new Date().toLocaleString("default", {
    month: "long",
  });

  const [openMonth, setOpenMonth] = useState(currentMonth);

  const toggleMonth = (month) => {
    setOpenMonth((prev) => (prev === month ? null : month));
  };

  const getHolidayLabel = ({ date, occasion }) => {
    const d = new Date(date);
    const day = d.toLocaleDateString("en-US", { weekday: "long" });

    const cleanOccasion = occasion?.trim();
    const isWeekend = day === "Saturday" || day === "Sunday";

    if (isWeekend) {
      return cleanOccasion &&
        cleanOccasion !== "Saturday" &&
        cleanOccasion !== "Sunday"
        ? cleanOccasion
        : "Weekend";
    }

    return cleanOccasion;
  };

  const calendarScrollRef = useRef(null);

  useEffect(() => {
    if (isCalendarOpen && calendarScrollRef.current) {
      calendarScrollRef.current.scrollTop = GlobalConfiguration.lengthCheckZero;
    }
  }, [isCalendarOpen]);

  const [isCalendarOpenScroll, setIsCalendarOpenScroll] = useState(false);

  const pageScrollRef = useRef(null);
  useEffect(() => {
    if (isCalendarOpenScroll && pageScrollRef.current) {
      pageScrollRef.current.scrollTop = GlobalConfiguration.lengthCheckZero;
    }
  }, [isCalendarOpenScroll]);

  const transactionSlidingArray = [
    {
      key: "pay",
      items: [
        {
          img: "https://q2pay.in/new_assets/common/home_dashboard_icons/beneficiary_transaction_with_blue_circle.svg",
          title: "Beneficiary",
          desc: <>Select category and pay a beneficiary</>,
          service: "CBeneficiaryTxn",
          navigateTo:
            "/beneficiary_transaction_dashboard/create_beneficiary_transaction",
        },
        {
          img: "https://q2pay.in/new_assets/common/home_dashboard_icons/internal_transaction_with_blue_circle.svg",
          title: "Internal",
          desc: <>Transfer funds from one owner account to another</>,
          service: "CInternalTxn",
          navigateTo:
            "/internal_transaction_dashboard/create_internal_transaction",
        },
        /* ---------- New items ---------- */
        // {
        //   img: "https://q2pay.in/new_assets/common/home_dashboard_icons/internal_transaction_with_blue_circle.svg",
        //   title: "Reimbursement",
        //   desc: <>Create a reimbursement transaction</>,
        //   service: "DUMMY_REIMBURSEMENT",
        //   navigateTo: "#",
        // },
        // {
        //   img: "https://q2pay.in/new_assets/common/home_dashboard_icons/internal_transaction_with_blue_circle.svg",
        //   title: "Field Force",
        //   desc: <>Create a field force transaction</>,
        //   service: "DUMMY_FIELD_FORCE",
        //   navigateTo: "#",
        // },
        // {
        //   img: "https://q2pay.in/new_assets/common/home_dashboard_icons/internal_transaction_with_blue_circle.svg",
        //   title: "Private",
        //   desc: (
        //     <>
        //       Description text Description text Description text Description
        //       text
        //     </>
        //   ),
        //   service: "DUMMY_PRIVATE_TXN",
        //   navigateTo: "#",
        // },
        // {
        //   img: "https://q2pay.in/new_assets/common/home_dashboard_icons/internal_transaction_with_blue_circle.svg",
        //   title: "Tax",
        //   desc: <>Create a tax transaction</>,
        //   service: "DUMMY_TAX",
        //   navigateTo: "#",
        // },
      ],
    },
    {
      key: "approve",
      items: [
        {
          img: "https://q2pay.in/new_assets/common/home_dashboard_icons/beneficiary_transaction_with_blue_circle.svg",
          title: `Beneficiary - ${
            !services?.includes("ABeneficiaryTxn")
              ? "N/A"
              : (beneficiaryTxnCount?.toString().padStart(2, "0") ?? "00")
          }`,
          desc: (
            <>
              Approve the transactions for fund transfer from owner to the
              beneficiary
            </>
          ),
          service: "ABeneficiaryTxn",
          navigateTo:
            "/beneficiary_transaction_dashboard/beneficiary_transaction_single_approval",
        },
        {
          img: "https://q2pay.in/new_assets/common/home_dashboard_icons/internal_transaction_with_blue_circle.svg",
          title: `Internal - ${
            !services?.includes("AInternalTxn")
              ? "N/A"
              : (internalTxnCount?.toString().padStart(2, "0") ?? "00")
          }`,
          desc: (
            <>
              Approve the transactions for fund transfer between owner accounts
            </>
          ),
          service: "AInternalTxn",
          navigateTo:
            "/internal_transaction_dashboard/internal_transaction_single_approval",
        },
        /* ---------- New items ---------- */
        // {
        //   img: "https://q2pay.in/new_assets/common/home_dashboard_icons/internal_transaction_with_blue_circle.svg",
        //   title: "Reimbursement",
        //   desc: (
        //     <>
        //       Description text Description text Description text Description
        //       text
        //     </>
        //   ),
        //   service: "DUMMY_REIMBURSEMENT",
        //   navigateTo: "#",
        // },
        // {
        //   img: "https://q2pay.in/new_assets/common/home_dashboard_icons/internal_transaction_with_blue_circle.svg",
        //   title: "Field Force",
        //   desc: (
        //     <>
        //       Approve the transactions for fund transfer from owner to field
        //       force
        //     </>
        //   ),
        //   service: "DUMMY_FIELD_FORCE",
        //   navigateTo: "#",
        // },
        // {
        //   img: "https://q2pay.in/new_assets/common/home_dashboard_icons/internal_transaction_with_blue_circle.svg",
        //   title: "Private",
        //   desc: (
        //     <>
        //       Description text Description text Description text Description
        //       text
        //     </>
        //   ),
        //   service: "DUMMY_PRIVATE_TXN",
        //   navigateTo: "#",
        // },
        // {
        //   img: "https://q2pay.in/new_assets/common/home_dashboard_icons/internal_transaction_with_blue_circle.svg",
        //   title: "Tax",
        //   desc: (
        //     <>
        //       Description text Description text Description text Description
        //       text
        //     </>
        //   ),
        //   service: "DUMMY_TAX",
        //   navigateTo: "#",
        // },
      ],
    },
    {
      key: "receive",
      items: [
        {
          img: "https://q2pay.in/new_assets/common/home_dashboard_icons/beneficiary_transaction_with_blue_circle.svg",
          title: "Bene",
          desc: (
            <>
              Approve the transactions for fund transfer
              <br className="hidden lg:inline" />
              from owner to the beneficiary
            </>
          ),
          service: "RCTXN",
          navigateTo: "/transaction/receive",
        },
      ],
    },
  ];

  const accountSlidingArray = [
    {
      key: "create",
      items: [
        {
          img: "https://q2pay.in/new_assets/common/home_dashboard_icons/beneficiary_account_with_blue_circle.svg",
          title: `Beneficiary`,
          desc: `Create a beneficiary account`,
          requiredService: "BUAccount",
          path: "/beneficiary_account_dashboard/create_beneficiary_account",
        },
        // {
        //   img: "https://q2pay.in/new_assets/common/home_dashboard_icons/reimbursement_accounts_with_blue_circle.svg",
        //   title: `Reimbursement`,
        //   desc: (
        //     <>
        //       Create a reimbursement
        //       <br className="hidden lg:inline" /> account
        //     </>
        //   ),
        //   requiredService: "BUAccount",
        //   path: "/reimbursement_account_dashboard/create_reimbursement_account",
        // },
        // {
        //   img: "https://q2pay.in/new_assets/common/home_dashboard_icons/internal_transaction_with_blue_circle.svg",
        //   title: "Field Force",
        //   desc: (
        //     <>
        //       Create a field force
        //       <br className="hidden lg:inline" /> account
        //     </>
        //   ),
        //   service: "DUMMY_FIELD_FORCE",
        //   navigateTo: "#",
        // },
        // {
        //   img: "https://q2pay.in/new_assets/common/home_dashboard_icons/internal_transaction_with_blue_circle.svg",
        //   title: "Tax",
        //   desc: (
        //     <>
        //       Create a tax
        //       <br className="hidden lg:inline" /> account
        //     </>
        //   ),
        //   service: "DUMMY_TAX",
        //   navigateTo: "#",
        // },
      ],
    },
    {
      key: "approve",
      items: [
        {
          img: "https://q2pay.in/new_assets/common/home_dashboard_icons/beneficiary_account_with_blue_circle.svg",
          title: `Beneficiary - ${
            services?.includes("BAAccount")
              ? beneficiaryAccountCount &&
                beneficiaryAccountCount > GlobalConfiguration.lengthCheckZero
                ? beneficiaryAccountCount
                : "00"
              : "N/A"
          }`,
          desc: "Approve beneficiary accounts",
          requiredService: "BAAccount",
          path: "/beneficiary_account_dashboard/beneficiary_account_approval",
        },
        {
          img: "https://q2pay.in/new_assets/common/home_dashboard_icons/internal_transaction_with_blue_circle.svg",
          title: `Internal - ${
            services?.includes("IAAccount")
              ? internalAccountCount &&
                internalAccountCount > GlobalConfiguration.lengthCheckZero
                ? internalAccountCount
                : "00"
              : "N/A"
          }`,
          desc: "Approve internal accounts",
          requiredService: "IAAccount",
          path: "/internal_account_dashboard/internal_account_approval",
        },
        // {
        //   img: "https://q2pay.in/new_assets/common/home_dashboard_icons/internal_transaction_with_blue_circle.svg",
        //   title: `Reimbursement`,
        //   desc: (
        //     <>
        //       Create a reimbursement
        //       <br className="hidden lg:inline" /> account
        //     </>
        //   ),
        //   requiredService: "DUMMY_REIMBURSEMENT",
        //   path: "#",
        // },
        // {
        //   img: "https://q2pay.in/new_assets/common/home_dashboard_icons/internal_transaction_with_blue_circle.svg",
        //   title: "Field Force",
        //   desc: (
        //     <>
        //       Create a field force
        //       <br className="hidden lg:inline" /> account
        //     </>
        //   ),
        //   service: "DUMMY_FIELD_FORCE",
        //   navigateTo: "#",
        // },
        // {
        //   img: "https://q2pay.in/new_assets/common/home_dashboard_icons/internal_transaction_with_blue_circle.svg",
        //   title: "Tax",
        //   desc: (
        //     <>
        //       Create a tax
        //       <br className="hidden lg:inline" /> account
        //     </>
        //   ),
        //   service: "DUMMY_TAX",
        //   navigateTo: "#",
        // },
      ],
    },
  ];

  /* ---------------- TRANSACTIONS ---------------- */
  const formattedDate = useMemo(() => {
    if (holidays.length === 0) return null;

    const d = new Date(holidays[0].date);
    if (isNaN(d)) return null;

    const day = d.toLocaleString("en-GB", { day: "numeric" });
    const month = d.toLocaleString("en-GB", { month: "short" });
    const year = d.getFullYear();

    return `${day} ${month}, ${year}`;
  }, [holidays]);

  const txnKey = openTxnSlider;

  const txnItems =
    transactionSlidingArray.find((c) => c.key === txnKey)?.items ?? [];

  const TXN_MAX_PER_SLIDE = 3;

  const txnSlides = useMemo(() => {
    const result = [];
    for (let i = 0; i < txnItems.length; i += TXN_MAX_PER_SLIDE) {
      result.push(txnItems.slice(i, i + TXN_MAX_PER_SLIDE));
    }
    return result;
  }, [txnItems]);

  const [txnActiveSlide, setTxnActiveSlide] = useState(
    GlobalConfiguration.lengthCheckZero,
  );

  const txnActiveItems = txnSlides[txnActiveSlide] ?? [];

  /* ---------------- ACCOUNTS ---------------- */

  const accKey = openAccountSlider;

  const accItems =
    accountSlidingArray.find((c) => c.key === accKey)?.items ?? [];

  const ACC_MAX_PER_SLIDE = 2;

  const accSlides = useMemo(() => {
    const result = [];
    for (let i = 0; i < accItems.length; i += ACC_MAX_PER_SLIDE) {
      result.push(accItems.slice(i, i + ACC_MAX_PER_SLIDE));
    }
    return result;
  }, [accItems]);

  const [accActiveSlide, setAccActiveSlide] = useState(
    GlobalConfiguration.lengthCheckZero,
  );

  const accActiveItems = accSlides[accActiveSlide] ?? [];

  useEffect(() => {
    setTxnActiveSlide(GlobalConfiguration.lengthCheckZero);
  }, [openTxnSlider]);

  useEffect(() => {
    setAccActiveSlide(GlobalConfiguration.lengthCheckZero);
  }, [openAccountSlider]);

  return (
    <div
      ref={pageScrollRef}
      style={{ height: "var(--full-height)" }}
      className={`bg-primary-bg w-width-full pt-padding-xl px-padding-sm lg:px-padding-lg pb-padding-md  ${
        isCalendarOpen ? "ScrollingBehavior" : "overflow-y-auto"
      }`}
    >
      {openMessagePanel &&
        activeLabel?.toLowerCase() === "alert" &&
        alertCount === GlobalConfiguration.lengthCheckOne && (
          <div className="fixed top-0 left-0 w-screen h-screen bg-PopUp-BackDrop bg-opacity-dark-opacity z-z-index-modal">
            <SmallAlertPopup
              headerTitle="Alert"
              subtext="The following items require your attention."
              closehandleFunction={closePanel}
              isDataArray={DataArray}
              enabledTextColor="var(--text-primary)"
              enabledBgColor="var(--primary-act)"
              disabledBgColor="var(--primary-act)"
              btnOutLineColor=""
              disabledTextColor=""
              isLoading={false}
              btnhoverOption="white"
              btnFullWidthRequired={false}
              btnInActiveVariantNeeded={false}
              btnIsLoaderNeeded={false}
              buttonRef=""
            />
          </div>
        )}
      {/* ) : (
      <MessagePanel
        open={openMessagePanel}
        activeLabel={activeLabel}
        closePanel={closePanel}
        mainData={mainData}
        beneAccountsCount={beneAccountsCount}
        // setAlertCount={setAlertCount}
      /> */}
      <div className="flex flex-col Qsmd:mt-margin-xl mt-margin-lg  lg:mx-auto pb-padding-xl lg:pb-padding-base mb-margin-xl lg:mb-margin-base max-w-tab-width-normal w-width-full  gap-gap-md">
        <MultiEntityBanner
          sessionStatus={canConciergeLogin}
          showBanner={showBanner}
          setShowBanner={() => setBannerDismissed(true)}
        />
        <div className="flex Qsmd:flex-row flex-col gap-gap-md">
          <div className="w-width-full Qsmd:w-width-lg flex flex-col gap-gap-md lg:max-w-[var(--dashboard-left-card-width)]">
            <div className="home_dashboard_topBar w-width-full fixed lg:static Qsmd:static top-top-base left-left-base right-right-base bg-text-primary Qsmd:bg-primary-nav flex rounded-b-border-radius-sm Qsmd:rounded-border-radius-md lg:rounded-border-radius-md items-center z-z-index-fixed-ui Qmd:z-z-index-content pl-padding-md Qsmd:px-padding-base">
              <div className="lg:hidden Qsmd:hidden flex items-center">
                <img
                  src={ICONS?.XPENTRA_BLUE}
                  alt="Xpentra Logo"
                  className="w-[6.188rem]"
                />
              </div>

              <div className="flex-1 Qsmd:hidden "></div>

              <div className="flex flex-1 flex-shrink-0 justify-end items-center w-width-full gap-gap-base lg:max-w-[var(--dashboard-left-card-width)]">
                {[
                  {
                    label: "Alert",
                    count: alertCount,
                    requiredServices: [
                      "BUAccount",
                      "Admin",
                      "MimicEntity",
                      "BVAccount",
                    ],
                    icon: "https://q2pay.in/new_assets/common/dashboard/alert_white.svg",
                    activeIcon:
                      "https://q2pay.in/new_assets/common/dashboard/alert.svg",
                    activeColor: "var(--alert-red)",
                    inactiveColor: "var(--abandoned)",
                  },
                  {
                    label: "Reminder",
                    count: reminderTxnViewData?.total_count,
                    icon: "https://q2pay.in/new_assets/common/dashboard/reminders_white.svg",
                    activeColor: "var(--positive-act)",
                    inactiveColor: "var(--abandoned)",
                    requiredServices: ["Admin", "VReminder", "AReminder"],
                  },
                  {
                    label: "Announcement",
                    count: GlobalConfiguration.lengthCheckZero,
                    icon: "https://q2pay.in/new_assets/common/dashboard/announcement_grey.svg",
                    activeColor: "var(--emphasis)",
                    inactiveColor: "var(--abandoned)",
                  },
                ].map(
                  (
                    {
                      icon,
                      activeIcon,
                      label,
                      count,
                      requiredServices,
                      activeColor,
                      inactiveColor,
                    },
                    index,
                    arr,
                  ) => {
                    const servicesAvailable = requiredServices
                      ? Array.isArray(services) &&
                        requiredServices.some((service) =>
                          services?.includes(service),
                        )
                      : true;
                    const isDisabled =
                      label === "Announcement" ||
                      (label === "Reminder" && !servicesAvailable);

                    const handleClick = () => {
                      const hasServices = requiredServices
                        ? Array.isArray(services) &&
                          requiredServices.some((service) =>
                            services.includes(service),
                          )
                        : true;

                      if (
                        (label === "Reminder" || label === "Announcement") &&
                        !hasServices
                      ) {
                        navigate("/feature_not_assigned", {
                          state: { unavailableService: requiredServices },
                        });
                        return;
                      }

                      if (label === "Reminder") {
                        navigate("/home/reminders");
                        return;
                      }

                      if (
                        (label === "Alert" || label === "Announcement") &&
                        count === GlobalConfiguration.lengthCheckZero
                      ) {
                        return;
                      }
                      handleInfoPanel(label);
                    };

                    const isActive =
                      count > GlobalConfiguration.lengthCheckZero ||
                      (label === "Reminder" && !isDisabled);

                    const iconUrl =
                      label === "Alert" && isActive && activeIcon
                        ? activeIcon
                        : icon;

                    const iconColor =
                      label === "Alert"
                        ? undefined // Alert uses different SVGs, no color override
                        : isActive
                          ? activeColor
                          : inactiveColor;

                    return (
                      <>
                        <div
                          key={label}
                          className={`Qsmd:flex-1 items-center Qsmd:p-padding-sm relative group hover:bg-none ${
                            isDisabled ||
                            (label != "Reminder" &&
                              count === GlobalConfiguration.lengthCheckZero)
                              ? "opacity-light-opacity"
                              : "opacity-base-opacity"
                          }`}
                          onClick={handleClick}
                        >
                          <div
                            className={`flex Qsmd:justify-between items-center px-padding-sm py-padding-sm rounded-border-radius-md relative z-z-index-base ${
                              (count === GlobalConfiguration.lengthCheckZero &&
                                label !== "Reminder") ||
                              isDisabled
                                ? "Qsmd:cursor-not-allowed"
                                : "Qsmd:cursor-pointer global-hover-white"
                            }`}
                          >
                            <div
                              className={`text-font-xs font-semibold flex items-center gap-gap-sm rounded-md `}
                            >
                              <div className="w-icon-lg Qsmd:w-auto h-icon-lg Qsmd:h-auto bg-custom-appBack Qsmd:bg-transparent lg:bg-transparent flex justify-center items-center rounded-border-radius-sm lg:rounded-none relative">
                                <SVGComponent
                                  url={iconUrl}
                                  height="var(--icon-md)"
                                  width="var(--icon-md)"
                                  color={iconColor}
                                />
                                {count >
                                  GlobalConfiguration.lengthCheckZero && (
                                  <div className="w-alert-dot-width h-alert-dot-height Qsmd:hidden flex flex-shrink-0 bg-custom-appBackLight rounded-full absolute top-top-base right-right-base"></div>
                                )}
                              </div>

                              <span className="hidden Qsmd:flex text-Blue-3 sm:text-text-primary Qsmd:text-text-primary lg:text-text-primary">
                                {`${label}s`}
                              </span>
                            </div>

                            <div className="text-font-xs font-semibold hidden Qsmd:flex text-Blue-3 Qsmd:text-text-primary">
                              {label === "Reminder" &&
                              (reminderTxnViewLoading === null ||
                                reminderTxnViewLoading) ? (
                                <img
                                  src={
                                    "https://q2pay.in/new_assets/gifs/inputloader_white.gif"
                                  }
                                  alt="Loading..."
                                  className="h-icon-sm inline-block"
                                />
                              ) : label === "Alert" && !hasFetchedCount ? (
                                <img
                                  src={
                                    "https://q2pay.in/new_assets/gifs/inputloader_white.gif"
                                  }
                                  alt="Loading..."
                                  className="h-icon-sm inline-block"
                                />
                              ) : count >
                                GlobalConfiguration.lengthCheckZero ? (
                                String(count).padStart(
                                  GlobalConfiguration.lengthCheckTwo,
                                  "0",
                                )
                              ) : (
                                "00"
                              )}
                            </div>
                          </div>
                        </div>
                        {index !==
                          arr.length - GlobalConfiguration.lengthCheckOne && (
                          <div className="border-r-border border-primary-bg relative top-top-half h-screen max-h-[var(--category-icon-height)]"></div>
                        )}
                      </>
                    );
                  },
                )}
              </div>
            </div>

            <div className="w-width-full rounded-border-radius-md relative overflow-hidden">
              <div className="flex bg-primary-card rounded-t-border-radius-md ">
                <div
                  className={`relative py-padding-sm ${
                    openTxnSlider
                      ? "global-hover-white z-z-index-base cursor-pointer"
                      : ""
                  }`}
                  onClick={() => setOpenTxnSlider(null)}
                >
                  <div
                    className={`relative h-height-full border-primary-bg border-r-border top-top-base left-left-base flex items-center transition-all duration-animation-medium ${
                      openTxnSlider
                        ? "w-home-dashboard-back-arrow-width-slider"
                        : "w-width-base border-primary-card"
                    }`}
                  >
                    <div className="ml-margin-md">
                      <SVGComponent
                        url={
                          "https://q2pay.in/new_assets/common/arrows/arrow_left_white.svg"
                        }
                        color="var(--text-primary)"
                        height={"var(--icon-sm)"}
                        width={"var(--icon-sm)"}
                      />
                    </div>
                  </div>
                </div>
                <div
                  className={`w-full flex justify-between items-center px-padding-sm pl-padding-md py-padding-sm lg:py-padding-base my-margin-base lg:my-margin-sm transition-all duration-animation-medium ${
                    openTxnSlider
                      ? "rounded-tr-border-radius-md"
                      : "border-primary-bg"
                  }`}
                >
                  <div className="flex items-center gap-gap-sm">
                    <img
                      src={
                        "https://q2pay.in/new_assets/common/dashboard/transaction_white.svg"
                      }
                      alt="transcation header"
                      className="w-icon-sm h-icon-sm"
                    />
                    <span className="text-font-sm font-semibold text-text-primary ">
                      {!openTxnSlider
                        ? "Transactions"
                        : openTxnSlider === "pay"
                          ? "Pay"
                          : openTxnSlider === "receive"
                            ? "Receive"
                            : openTxnSlider === "approve"
                              ? "Approve"
                              : "Transactions"}
                    </span>
                  </div>
                  <div
                    className={`flex gap-gap-sm mr-margin-sm transition-all duration-animation-medium ${
                      openTxnSlider &&
                      txnSlides.length > GlobalConfiguration.lengthCheckOne
                        ? "opacity-base-opacity"
                        : "opacity-opacity-none cursor-default"
                    }`}
                  >
                    <div
                      onClick={() => {
                        if (
                          txnActiveSlide === GlobalConfiguration.lengthCheckZero
                        )
                          return;
                        setTxnActiveSlide(
                          (p) => p - GlobalConfiguration.lengthCheckOne,
                        );
                      }}
                      className={`${
                        txnActiveSlide === GlobalConfiguration.lengthCheckZero
                          ? "opacity-light-opacity cursor-not-allowed"
                          : "cursor-pointer"
                      }`}
                    >
                      <SVGComponent
                        url="https://q2pay.in/new_assets/common/arrows/arrow_left_white_circle.svg"
                        height="var(--icon-sm)"
                        width="var(--icon-sm)"
                      />
                    </div>

                    <div
                      onClick={() => {
                        if (
                          txnActiveSlide ===
                          txnSlides.length - GlobalConfiguration.lengthCheckOne
                        )
                          return;
                        setTxnActiveSlide(
                          (p) => p + GlobalConfiguration.lengthCheckOne,
                        );
                      }}
                      className={`${
                        txnActiveSlide ===
                        txnSlides.length - GlobalConfiguration.lengthCheckOne
                          ? "opacity-light-opacity cursor-not-allowed"
                          : "cursor-pointer"
                      }`}
                    >
                      <SVGComponent
                        url="https://q2pay.in/new_assets/common/arrows/arrow_right_white_circle.svg"
                        height="var(--icon-sm)"
                        width="var(--icon-sm)"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="relative bg-primary-nav w-width-full h-height-full overflow-hidden">
                <div
                  className={`flex w-width-double transition-transform duration-animation-medium ease-in-out ${openTxnSlider ? "-translate-x-1/2" : "translate-x-0"}`}
                >
                  <div
                    className={`grid Qsmd:grid-cols-3 grid-cols-1 w-width-md relative transition-transform duration-animation-medium`}
                  >
                    {[
                      {
                        img: "https://q2pay.in/new_assets/common/home_dashboard_icons/pay_with_blue_circle.svg",
                        title: "Pay",
                        desc: "Create an outgoing transaction",
                        type: "pay",
                        txnRequiredServices: [
                          "CBeneficiaryTxn",
                          "CInternalTxn",
                        ],
                      },
                      {
                        img: "https://q2pay.in/new_assets/common/home_dashboard_icons/recieve_with_blue_circle.svg",
                        title: "Receive",
                        desc: "Create an incoming transaction",
                        type: "receive",
                        txnRequiredServices: ["RCTXN"],
                      },
                      {
                        img: "https://q2pay.in/new_assets/common/home_dashboard_icons/approve_with_blue_circle.svg",
                        title: (
                          <>
                            Approve -&nbsp;
                            {beneTxnViewAllAccLoading ||
                            internalTxnViewAllAccLoading ||
                            txnCountLoading ? (
                              <img
                                src={
                                  "https://q2pay.in/new_assets/gifs/inputloader_white.gif"
                                }
                                alt="Loading..."
                                className="h-icon-sm inline-block"
                              />
                            ) : (
                              (() => {
                                const hasBeneficiaryService =
                                  services?.includes("ABeneficiaryTxn");
                                const hasInternalService =
                                  services?.includes("AInternalTxn");

                                if (
                                  !hasBeneficiaryService &&
                                  !hasInternalService
                                ) {
                                  return "N/A";
                                }

                                const txnTotalCount =
                                  Number(
                                    hasBeneficiaryService && beneficiaryTxnCount
                                      ? beneficiaryTxnCount
                                      : GlobalConfiguration.lengthCheckZero,
                                  ) +
                                  Number(
                                    hasInternalService && internalTxnCount
                                      ? internalTxnCount
                                      : GlobalConfiguration.lengthCheckZero,
                                  );
                                return txnTotalCount <
                                  GlobalConfiguration.panLength
                                  ? txnTotalCount
                                      .toString()
                                      .padStart(
                                        GlobalConfiguration.lengthCheckTwo,
                                        "0",
                                      )
                                  : txnTotalCount.toLocaleString("en-IN");
                              })()
                            )}
                          </>
                        ),
                        desc: "Approve the created transactions",
                        type: "approve",
                        txnRequiredServices: [
                          "ABeneficiaryTxn",
                          "AInternalTxn",
                        ],
                      },
                    ].map((item, index) => {
                      const isTxnServiceAvailable =
                        item.txnRequiredServices.some((service) =>
                          services?.includes(service),
                        );

                      return (
                        <div key={index}>
                          <div
                            className={`w-width-full flex-1 relative z-z-index-base bg-primary-nav flex Qsmd:flex-col flex-row flex-shrink-0 items-center Qsmd:justify-center text-center px-padding-md Qsmd:py-padding-lg py-padding-sm ${
                              isTxnServiceAvailable
                                ? "cursor-pointer global-hover-white"
                                : "cursor-not-allowed"
                            }`}
                            onClick={() => {
                              if (isTxnServiceAvailable) {
                                setOpenTxnSlider(item.type);
                              } else if (!isTxnServiceAvailable) {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService:
                                      item.txnRequiredServices,
                                  },
                                });
                              }
                            }}
                          >
                            <img
                              src={item.img}
                              alt={
                                typeof item.title === "string"
                                  ? item.title
                                  : "Txn"
                              }
                              className={`w-icon-lg h-icon-lg Qsmd:mb-margin-xs ${
                                !isTxnServiceAvailable &&
                                "opacity-light-opacity"
                              }`}
                            />
                            <div
                              className={`Qsmd:ml-margin-base ml-margin-sm flex flex-col Qsmd:items-center items-start ${
                                !isTxnServiceAvailable &&
                                "opacity-light-opacity"
                              }`}
                            >
                              <p className="text-font-md Qsmd:text-font-md font-semibold text-text-primary pb-padding-xs flex items-center">
                                {isNaN(item.title)
                                  ? item.title
                                  : Number(item.title).toLocaleString("en-IN")}
                              </p>

                              <div className="text-font-xs text-text-secondary">
                                {item.desc.split(" ").slice(0, 3).join(" ")}
                                &nbsp;
                                <br className="hidden Qsmd:block" />
                                {item.desc.split(" ").slice(3).join(" ")}
                              </div>
                            </div>
                          </div>

                          {index < 2 && (
                            <div
                              className={`flex Qsmd:block absolute z-z-index-content Qsmd:top-top-half transform Qsmd:-translate-y-1/2 Qsmd:h-height-lg w-slider-items-seperator-line-width Qsmd:w-auto ml-margin-md Qsmd:ml-margin-base border-t-border Qsmd:border-t-border-base Qsmd:border-r-border border-primary-bg ${
                                index === GlobalConfiguration.lengthCheckZero
                                  ? "Qsmd:left-1/3"
                                  : "Qsmd:left-2/3"
                              }`}
                            ></div>
                          )}
                        </div>
                      );
                    })}
                  </div>

                  <div
                    className={`z-z-index-content bottom-bottom-base top-top-base right-right-base w-width-md bg-primary-nav transition-transform duration-animation-medium flex items-center justify-center `}
                  >
                    {["pay", "receive", "approve"].includes(openTxnSlider) && (
                      <div className="relative w-width-full h-height-full overflow-hidden">
                        {/* TRACK */}
                        <div
                          className="flex h-height-full transition-transform duration-animation-medium ease-in-out"
                          style={{
                            transform: `translateX(-${txnActiveSlide * PaginationConfiguration.paginationBig}%)`,
                          }}
                        >
                          {/* SLIDES */}
                          {txnSlides.map((slideItems, slideIndex) => (
                            <div
                              key={slideIndex}
                              className="w-width-full flex-shrink-0"
                            >
                              <div
                                className={`flex flex-col Qsmd:grid h-height-full ${
                                  slideItems.length ===
                                  GlobalConfiguration.lengthCheckOne
                                    ? "Qsmd:grid-cols-1"
                                    : slideItems.length ===
                                        GlobalConfiguration.lengthCheckTwo
                                      ? "Qsmd:grid-cols-2"
                                      : "Qsmd:grid-cols-3"
                                } text-center Qsmd:justify-center`}
                              >
                                {/* CARDS */}
                                {slideItems.map((item, index) => {
                                  const isLastItem =
                                    index ===
                                    slideItems.length -
                                      GlobalConfiguration.lengthCheckOne;

                                  const isTxnServiceAvailable =
                                    services?.includes(item?.service);

                                  const txnCount =
                                    item.title?.match(/\d+/)?.[
                                      GlobalConfiguration.lengthCheckZero
                                    ];
                                  const isTxnCountValid =
                                    openTxnSlider === "approve"
                                      ? Number(txnCount) >
                                        GlobalConfiguration.lengthCheckZero
                                      : true;

                                  const isCardTxnEnabled =
                                    isTxnServiceAvailable && isTxnCountValid;

                                  return (
                                    <div
                                      key={index}
                                      className="w-width-full relative Qsmd:h-height-full"
                                    >
                                      <div
                                        className={`Qsmd:bg-primary-nav relative h-height-full z-z-index-base flex gap-gap-xs Qsmd:flex-col flex-row items-center Qsmd:justify-center text-center px-padding-md Qsmd:px-padding-base py-padding-sm Qsmd:py-padding-lg ${
                                          !isCardTxnEnabled
                                            ? "opacity-light-opacity cursor-not-allowed"
                                            : "opacity-base-opacity cursor-pointer global-hover-white"
                                        }`}
                                        onClick={() => {
                                          if (isCardTxnEnabled) {
                                            navigate(item.navigateTo);
                                            sessionStorage.removeItem(
                                              "recreate_ben",
                                            );
                                          } else if (!isTxnServiceAvailable) {
                                            navigate("/feature_not_assigned", {
                                              state: {
                                                unavailableService:
                                                  item.service,
                                              },
                                            });
                                          }
                                        }}
                                      >
                                        {item.img && (
                                          <img
                                            src={item.img}
                                            alt={item.title}
                                            className="w-icon-lg h-icon-lg"
                                          />
                                        )}

                                        <div className="ml-margin-sm Qsmd:ml-margin-base flex flex-col gap-gap-xs Qsmd:items-center items-start">
                                          <p className="text-font-md font-semibold text-text-primary">
                                            {item.title}
                                          </p>

                                          {item.desc && (
                                            <p className="text-font-xs Qsmd:px-padding-md text-text-secondary leading-tight Qsmd:text-center text-left">
                                              {item.desc}
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                      {/* SEPARATOR */}
                                      {!isLastItem && (
                                        <div
                                          className={`flex Qsmd:block absolute Qsmd:top-top-half Qsmd:-translate-y-1/2 Qsmd:h-height-lg w-slider-items-seperator-line-width Qsmd:w-auto ml-margin-md Qsmd:ml-margin-base border-t-border Qsmd:border-t-border-base Qsmd:border-r-border border-primary-bg ${
                                            slideItems.length ===
                                            GlobalConfiguration.lengthCheckOne
                                              ? ""
                                              : slideItems.length === 2
                                                ? "Qsmd:right-right-base"
                                                : "Qsmd:right-right-base"
                                          }`}
                                        />
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="w-width-full bg-primary-nav rounded-t-border-radius-md rounded-b-border-radius-md">
              <h2 className="bg-primary-card flex items-center justify-between px-padding-md py-padding-sm text-font-sm font-semibold text-text-secondary transition-all duration-animation-fast rounded-t-border-radius-md">
                <span className="flex items-center">
                  <img
                    src={
                      "https://q2pay.in/new_assets/common/settings/statistics.svg"
                    }
                    alt="Statistics Header"
                    className="w-icon-sm h-icon-sm mr-margin-sm"
                  />
                  Statistics
                </span>

                {slides.length > GlobalConfiguration.lengthCheckZero && (
                  <div className="w-icon-lg flex items-center gap-gap-xs">
                    <div
                      onClick={prevSlide}
                      className={`cursor-pointer w-icon-sm h-icon-sm ${
                        currentSlide === GlobalConfiguration.lengthCheckZero
                          ? "opacity-light-opacity cursor-not-allowed"
                          : ""
                      }`}
                      style={{
                        pointerEvents:
                          currentSlide === GlobalConfiguration.lengthCheckZero
                            ? "none"
                            : "auto",
                      }}
                    >
                      <img
                        src={
                          "https://q2pay.in/new_assets/common/arrows/arrow_left_white_circle.svg"
                        }
                        alt="Previous"
                      />
                    </div>
                    <div
                      onClick={nextSlide}
                      className={`cursor-pointer w-icon-sm h-icon-sm ${
                        currentSlide ===
                        slides.length - GlobalConfiguration.lengthCheckOne
                          ? "opacity-light-opacity cursor-not-allowed"
                          : ""
                      }`}
                      style={{
                        pointerEvents:
                          currentSlide ===
                          slides.length - GlobalConfiguration.lengthCheckOne
                            ? "none"
                            : "auto",
                      }}
                    >
                      <img
                        src={
                          "https://q2pay.in/new_assets/common/arrows/arrow_right_white_circle.svg"
                        }
                        alt="Next"
                      />
                    </div>
                  </div>
                )}
              </h2>

              <div className="relative w-width-full overflow-hidden contents lg:block">
                {slides.length > GlobalConfiguration.lengthCheckZero ? (
                  <div
                    className="flex transition-transform duration-animation-fast ease-in-out"
                    style={{
                      transform: `translateX(-${currentSlide * PaginationConfiguration.paginationBig}%)`,
                    }}
                  >
                    {slides.map((slide, index) => (
                      <div
                        key={index}
                        className="w-width-full flex-shrink-0 flex items-center justify-center h-height-md"
                      >
                        {slide}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="flex flex-col items-center justify-center lg:justify-start h-full text-center p-padding-md">
                    <div className="flex flex-col justify-center items-center w-width-full">
                      <img
                        src={
                          "https://q2pay.in/new_assets/graphics/no_data/no_statistics_available.svg"
                        }
                        alt="No Slides"
                        className="w-width-md h-height-md max-h-max-height-top-slider mb-padding-md"
                      />
                      <p className="text-font-xs text-text-primary py-padding-md">
                        Click below to open the statistics page, then select
                        ‘Add to home screen.’
                        <br />
                        Added stats will appear here.
                      </p>
                      <PrimaryWithIconButton
                        icon={
                          "https://q2pay.in/new_assets/common/settings/add_button_white.svg"
                        }
                        imgColor="var(--text-primary)"
                        btnText=" Add statistics"
                        handleFunction={AddStatistics}
                        enabledBgColor="var(--primary-nav-act)"
                        enabledTextColor="var(--text-primary)"
                        hoverOption="white"
                        isDisabled={false}
                        iconToBeAlign="left"
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="flex flex-col lg:max-w-[var(--dashboard-right-card-width)] w-width-full Qsmd:w-width-sm">
            {/* Calender */}
            <div className="w-width-full bg-primary-card rounded-border-radius-md flex flex-col relative">
              <div className="flex gap-gap-sm items-center bg-primary-card rounded-t-border-radius-md py-padding-sm relative border-b border-primary-bg mx-margin-md">
                <SVGComponent
                  url={
                    "https://q2pay.in/new_assets/common/view_all/calender.svg"
                  }
                  height={"var(--icon-sm)"}
                  width={"var(--icon-sm)"}
                  color={"var(--text-primary)"}
                />
                <div className="text-font-sm font-semibold text-text-primary">
                  Upcoming Bank Holidays - {new Date().getFullYear()}
                </div>
              </div>

              <div className="w-width-full px-padding-md py-padding-sm flex flex-col gap-gap-sm">
                <div>
                  {holidays.length > GlobalConfiguration.lengthCheckZero ? (
                    <>
                      <p className="text-font-lg pb-padding-xs font-semibold text-text-primary">
                        <span>{formattedDate}</span>
                      </p>

                      <p className="text-font-xxs font-semibold truncate overflow-hidden text-text-secondary">
                        {`${new Date(
                          holidays[GlobalConfiguration.lengthCheckZero].date,
                        )
                          .toLocaleDateString("en-US", { weekday: "long" })
                          .slice(
                            GlobalConfiguration.lengthCheckZero,
                            3,
                          )} - ${getHolidayLabel(holidays[GlobalConfiguration.lengthCheckZero])}`}
                      </p>
                    </>
                  ) : (
                    <p className="text-font-sm text-text-primary">
                      No upcoming holidays this month.
                    </p>
                  )}
                </div>

                <div className="flex justify-end">
                  <PrimaryWithIconButton
                    btnText="View more"
                    handleFunction={() => {
                      if (
                        holidays.length !== GlobalConfiguration.lengthCheckZero
                      ) {
                        setIsCalendarOpen(true);
                        dispatch(toggleCalendar(true));
                        setIsCalendarOpenScroll(true);
                      }
                    }}
                    icon="https://q2pay.in/new_assets/common/arrows/arrow_down_white.svg"
                    enabledBgColor="var(--primary-nav-act)"
                    enabledTextColor="var(--text-primary)"
                    imgColor="var(--text-primary)"
                    hoverOption="white"
                    isDisabled={
                      holidays.length === GlobalConfiguration.lengthCheckZero
                    }
                    iconToBeAlign="right"
                  />
                </div>

                {/* <div className="calenderMob"> */}
                <div
                  className="fixed top-top-base left-left-base w-screen h-screen flex z-z-index-modal bg-custom-backdrop bg-opacity-dark-opacity"
                  style={{ display: isCalendarOpen ? "block" : "none" }}
                  onClick={() => {
                    setIsCalendarOpen(false);
                    dispatch(toggleCalendar(false));
                  }}
                ></div>
                <div className={`absolute z-z-index-modal inset-0 h-0`}>
                  <div
                    className={`bg-primary-card rounded-border-radius-md shadow-lg w-width-full max-w-md hidden Qsmd:flex flex-col ${
                      isCalendarOpen ? "h-auto block" : "none"
                    } relative ${showBanner ? "modal-banner" : "inset-0"} flex ${
                      isCalendarOpen === true
                        ? "opened"
                        : isCalendarOpen === false
                          ? "closed"
                          : "defaultclose"
                    }
`}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="flex gap-gap-sm items-center rounded-t-border-radius-md py-padding-sm border-b border-primary-bg mx-margin-md relative">
                      <SVGComponent
                        url={
                          "https://q2pay.in/new_assets/common/view_all/calender.svg"
                        }
                        height={"var(--icon-sm)"}
                        width={"var(--icon-sm)"}
                        color={"var(--text-primary)"}
                      />
                      <div className="text-font-sm font-semibold text-text-primary">
                        Upcoming Bank Holidays - {new Date().getFullYear()}
                      </div>
                    </div>
                    <div
                      ref={calendarScrollRef}
                      className="overflow-y-auto bg-primary-card"
                      style={{
                        height: showBanner
                          ? "calc(var(home-modal-height-content) - var(--home-modal-offset-base))"
                          : "calc(var(home-modal-height-content) - var(--home-modal-offset-banner))",
                      }}
                    >
                      {Object.keys(holidaysByMonth).map((month, index) => {
                        const isOpen = openMonth === month;
                        const isLast =
                          index ===
                          Object.keys(holidaysByMonth).length -
                            GlobalConfiguration.lengthCheckOne;
                        return (
                          <>
                            <div
                              key={month}
                              className={`overflow-hidden ${isLast ? "" : "border-b border-primary-bg"} mx-margin-sm`}
                            >
                              {/* Month Header */}
                              <div className="w-width-full py-padding-sm">
                                <div
                                  onClick={() => {
                                    toggleMonth(month);
                                  }}
                                  className="w-width-full bg-primary-card global-hover-white rounded-border-radius-md text-font-sm flex items-center justify-between relative z-z-index-base p-padding-sm cursor-pointer"
                                >
                                  <span className="text-text-primary">
                                    {month}
                                  </span>

                                  {/* Arrow */}
                                  <div
                                    className={`transition-transform duration-animation-fast ${
                                      isOpen ? "rotate-half" : "rotate-base"
                                    }`}
                                  >
                                    <SVGComponent
                                      url={
                                        "https://q2pay.in/new_assets/common/arrows/arrow_down_white.svg"
                                      }
                                      height={"var(--icon-sm)"}
                                      width={"var(--icon-sm)"}
                                      color={"var(--text-primary)"}
                                    />
                                  </div>
                                </div>
                              </div>

                              {/* Accordion Content */}
                              <div
                                className={`grid transition-all duration-animation-fast ease-in-out bg-primary-card px-padding-sm ${
                                  isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                                }`}
                              >
                                <div className="overflow-hidden">
                                  {holidaysByMonth[month].map(
                                    (holiday, index) => (
                                      <div key={holiday.id}>
                                        <HolidayCard
                                          index={index}
                                          date={holiday.date}
                                          occasion={holiday.occasion}
                                        />

                                        {index <
                                          holidaysByMonth[month].length -
                                            GlobalConfiguration.lengthCheckOne && (
                                          <div className="border-t border-primary-bg" />
                                        )}
                                      </div>
                                    ),
                                  )}
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}
                    </div>
                    <div className="absolute bottom-bottom-base flex justify-end py-padding-sm px-padding-md w-width-full bg-primary-card rounded-b-border-radius-md">
                      <PrimaryWithIconButton
                        btnText="View less"
                        handleFunction={() => {
                          setOpenMonth(null);
                          setIsCalendarOpen(false);
                          dispatch(toggleCalendar(false));
                          setOpenMonth(currentMonth);
                          setIsCalendarOpenScroll(false);
                        }}
                        icon="https://q2pay.in/new_assets/common/arrows/arrow_up_white.svg"
                        enabledBgColor="var(--primary-nav-act)"
                        enabledTextColor="var(--text-primary)"
                        imgColor="var(--text-primary)"
                        hoverOption="white"
                        iconToBeAlign="right"
                      />
                    </div>
                    <div className="h-mobile-navbar-height flex-shrink-0"></div>
                  </div>
                </div>
                {/* </div> */}
              </div>
            </div>

            {isCalendarOpen && (
              <div
                className="calenderWebPopUp Qsmd:hidden block"
                onClick={() => setIsCalendarOpen(false)}
              >
                <div className="fixed top-top-base left-left-base w-screen h-screen flex z-z-index-fixed-ui bg-custom-backdrop bg-opacity-dark-opacity"></div>
                <div className="inset-0 flex justify-center items-center z-z-index-modal absolute px-padding-md Qsm:px-padding-base">
                  <div
                    className={`bg-primary-card rounded-border-radius-md shadow-lg w-width-full max-w-[var(--max-width-holiday-calendar)] flex flex-col origin-top ${
                      isCalendarOpen ? "h-auto block" : "none"
                    } relative flex Qmd:animate-none animate-slideInFromRight max-h-[var(--home-modal-height-end)]`}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="flex gap-gap-sm items-center rounded-t-border-radius-md py-padding-sm border-b border-primary-bg mx-margin-md relative">
                      <SVGComponent
                        url={
                          "https://q2pay.in/new_assets/common/view_all/calender.svg"
                        }
                        height={"var(--icon-sm)"}
                        width={"var(--icon-sm)"}
                        color={"var(--text-primary)"}
                      />
                      <div className="text-font-sm font-semibold text-text-primary">
                        Upcoming Bank Holidays - {new Date().getFullYear()}
                      </div>
                    </div>
                    <div
                      ref={calendarScrollRef}
                      className="overflow-y-auto bg-primary-card"
                      style={{
                        height: showBanner
                          ? "calc(var(home-modal-height-content) - var(--home-modal-offset-base))"
                          : "calc(var(home-modal-height-content) - var(--home-modal-offset-banner))",
                      }}
                    >
                      {Object.keys(holidaysByMonth).map((month, index) => {
                        const isOpen = openMonth === month;
                        const isLast =
                          index ===
                          Object.keys(holidaysByMonth).length -
                            GlobalConfiguration.lengthCheckOne;
                        return (
                          <>
                            <div
                              key={month}
                              className={`overflow-hidden ${isLast ? "" : "border-b border-primary-bg"} mx-margin-sm`}
                            >
                              {/* Month Header */}
                              <div className="w-width-full py-padding-sm">
                                <div
                                  onClick={() => {
                                    toggleMonth(month);
                                  }}
                                  className="w-width-full bg-primary-card global-hover-white rounded-border-radius-md text-font-sm flex items-center justify-between relative z-z-index-base p-padding-sm cursor-pointer"
                                >
                                  <span className="text-text-primary">
                                    {month}
                                  </span>

                                  {/* Arrow */}
                                  <div
                                    className={`transition-transform duration-animation-fast ${
                                      isOpen ? "rotate-half" : "rotate-base"
                                    }`}
                                  >
                                    <SVGComponent
                                      url={
                                        "https://q2pay.in/new_assets/common/arrows/arrow_down_white.svg"
                                      }
                                      height={"var(--icon-sm)"}
                                      width={"var(--icon-sm)"}
                                      color={"var(--text-primary)"}
                                    />
                                  </div>
                                </div>
                              </div>

                              {/* Accordion Content */}
                              <div
                                className={`grid transition-all duration-animation-fast ease-in-out bg-primary-card px-padding-sm ${
                                  isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                                }`}
                              >
                                <div className="overflow-hidden">
                                  {holidaysByMonth[month].map(
                                    (holiday, index) => (
                                      <div key={holiday.id}>
                                        <HolidayCard
                                          index={index}
                                          date={holiday.date}
                                          occasion={holiday.occasion}
                                        />

                                        {index <
                                          holidaysByMonth[month].length -
                                            GlobalConfiguration.lengthCheckOne && (
                                          <div className="border-t border-primary-bg" />
                                        )}
                                      </div>
                                    ),
                                  )}
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}
                    </div>
                    <div className="absolute bottom-bottom-base flex justify-end py-padding-sm px-padding-md w-width-full bg-primary-card rounded-b-border-radius-md">
                      <PrimaryWithIconButton
                        btnText="View less"
                        handleFunction={() => {
                          setOpenMonth(null);
                          setIsCalendarOpen(false);
                          dispatch(toggleCalendar(false));
                          setOpenMonth(currentMonth);
                        }}
                        icon="https://q2pay.in/new_assets/common/arrows/arrow_up_white.svg"
                        enabledBgColor="var(--primary-nav-act)"
                        enabledTextColor="var(--text-primary)"
                        imgColor="var(--text-primary)"
                        hoverOption="white"
                        iconToBeAlign="right"
                      />
                    </div>
                    <div className="h-mobile-navbar-height flex-shrink-0"></div>
                  </div>
                </div>
              </div>
            )}

            <div className="w-width-full lg:bg-primary-card bg-Blue-7 mt-margin-md rounded-border-radius-md relative overflow-hidden">
              <div className="flex bg-primary-card rounded-t-border-radius-md ">
                <div
                  className={`relative py-padding-sm ${
                    openAccountSlider
                      ? "global-hover-white z-z-index-base cursor-pointer"
                      : ""
                  }`}
                  onClick={() => setOpenAccountSlider(null)}
                >
                  <div
                    className={`relative h-height-full border-primary-bg border-r-border top-top-base left-left-base flex items-center transition-all duration-animation-medium ${
                      openAccountSlider
                        ? "w-home-dashboard-back-arrow-width-slider"
                        : "w-width-base border-primary-card"
                    }`}
                  >
                    <div className="ml-margin-md">
                      <SVGComponent
                        url={
                          "https://q2pay.in/new_assets/common/arrows/arrow_left_white.svg"
                        }
                        color="var(--text-primary)"
                        height={"var(--icon-sm)"}
                        width={"var(--icon-sm)"}
                      />
                    </div>
                  </div>
                </div>

                <div
                  className={`w-full flex justify-between items-center px-padding-sm pl-padding-md py-padding-sm lg:py-padding-base my-margin-base lg:my-margin-sm transition-all duration-animation-medium ${
                    openAccountSlider
                      ? "rounded-tr-border-radius-md"
                      : "border-primary-bg"
                  }`}
                >
                  <div className="flex items-center gap-gap-sm">
                    <img
                      src={
                        "https://q2pay.in/new_assets/common/dashboard/account_unselected.svg"
                      }
                      alt="transcation header"
                      className="w-icon-sm h-icon-sm"
                    />
                    <span className="text-font-sm font-semibold text-text-primary ">
                      {!openAccountSlider
                        ? "Accounts"
                        : openAccountSlider === "create"
                          ? "Create"
                          : openAccountSlider === "approve"
                            ? "Approve"
                            : "Transactions"}
                    </span>
                  </div>
                  <div
                    className={`flex gap-gap-sm mr-margin-sm transition-all duration-animation-medium ${(openAccountSlider || openAccountSlider === "approve") && accSlides.length > GlobalConfiguration.lengthCheckOne ? "opacity-base-opacity" : "opacity-opacity-none cursor-default"}`}
                  >
                    <div
                      onClick={() => {
                        if (
                          accActiveSlide === GlobalConfiguration.lengthCheckZero
                        )
                          return;
                        setAccActiveSlide(
                          (p) => p - GlobalConfiguration.lengthCheckOne,
                        );
                      }}
                      className={`${accActiveSlide === GlobalConfiguration.lengthCheckZero ? "opacity-light-opacity cursor-not-allowed" : ""} ${openAccountSlider || openAccountSlider === "approve" ? "cursor-pointer" : "cursor-default"}`}
                    >
                      <SVGComponent
                        url={
                          "https://q2pay.in/new_assets/common/arrows/arrow_left_white_circle.svg"
                        }
                        height={"var(--icon-sm)"}
                        width={"var(--icon-sm)"}
                      />
                    </div>
                    <div
                      onClick={() => {
                        if (
                          accActiveSlide ===
                          accSlides.length - GlobalConfiguration.lengthCheckOne
                        )
                          return;
                        setAccActiveSlide(
                          (p) => p + GlobalConfiguration.lengthCheckOne,
                        );
                      }}
                      className={`${accActiveSlide === accSlides.length - GlobalConfiguration.lengthCheckOne ? "opacity-light-opacity cursor-not-allowed" : ""} ${openTxnSlider || openTxnSlider === "approve" ? "cursor-pointer" : "cursor-default"}`}
                    >
                      <SVGComponent
                        url={
                          "https://q2pay.in/new_assets/common/arrows/arrow_right_white_circle.svg"
                        }
                        height={"var(--icon-sm)"}
                        width={"var(--icon-sm)"}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="relative bg-primary-nav w-width-full overflow-hidden">
                <div
                  className={`flex w-width-double transition-transform duration-animation-medium ease-in-out ${openAccountSlider ? "-translate-x-1/2" : "translate-x-0"}`}
                >
                  <div className="grid Qsmd:grid-cols-2 grid-cols-1 relative flex-shrink-0 w-width-md">
                    {[
                      {
                        img: "https://q2pay.in/new_assets/common/home_dashboard_icons/create_account_with_blue_circle.svg",
                        title: "Create",
                        desc: "Create accounts",
                        type: "create",
                        accountRequiredServices: ["BUAccount"],
                      },
                      {
                        img: "https://q2pay.in/new_assets/common/home_dashboard_icons/approve_with_blue_circle.svg",
                        title: (
                          <>
                            Approve -&nbsp;
                            {beneViewAllAccLoading ||
                            internalAccViewAllLoading ||
                            accountCountLoading ? (
                              <img
                                src={
                                  "https://q2pay.in/new_assets/gifs/inputloader_white.gif"
                                }
                                alt="Loading..."
                                className="h-icon-sm inline-block"
                              />
                            ) : (
                              (() => {
                                const hasBeneficiaryService =
                                  services?.includes("BAAccount");
                                const hasInternalService =
                                  services?.includes("IAAccount");

                                if (
                                  !hasBeneficiaryService &&
                                  !hasInternalService
                                ) {
                                  return "N/A";
                                }

                                const accountTotalCount =
                                  Number(
                                    hasBeneficiaryService &&
                                      beneficiaryAccountCount
                                      ? beneficiaryAccountCount
                                      : GlobalConfiguration.lengthCheckZero,
                                  ) +
                                  Number(
                                    hasInternalService && internalAccountCount
                                      ? internalAccountCount
                                      : GlobalConfiguration.lengthCheckZero,
                                  );
                                return accountTotalCount <
                                  GlobalConfiguration.panLength
                                  ? accountTotalCount
                                      .toString()
                                      .padStart(
                                        GlobalConfiguration.lengthCheckTwo,
                                        "0",
                                      )
                                  : accountTotalCount.toLocaleString("en-IN");
                              })()
                            )}
                          </>
                        ),
                        desc: "Approve the created accounts",
                        type: "approve",
                        accountRequiredServices: ["BAAccount", "IAAccount"],
                      },
                    ].map((item, index) => {
                      const isAccountServiceAvailable =
                        item.accountRequiredServices.some((service) =>
                          services?.includes(service),
                        );

                      return (
                        <div
                          key={index}
                          className="w-width-full Qsmd:relative"
                        >
                          <div
                            className={`w-width-full bg-primary-nav flex Qsmd:flex-col relative Qsmd:h-full flex-row items-center text-center px-padding-sm py-padding-sm Qsmd:py-padding-md mt-margin-base ${
                              isAccountServiceAvailable
                                ? "opacity-base-opacity cursor-pointer global-hover-white z-z-index-base"
                                : "opacity-light-opacity cursor-not-allowed"
                            }`}
                            onClick={() => {
                              if (isAccountServiceAvailable) {
                                setOpenAccountSlider(item.type);
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService:
                                      item.accountRequiredServices,
                                  },
                                });
                              }
                            }}
                          >
                            <img
                              src={item.img}
                              alt={item.title}
                              className={`w-icon-lg h-icon-lg Qsmd:mb-margin-xs ${
                                !isAccountServiceAvailable &&
                                "opacity-light-opacity"
                              }`}
                            />
                            <div
                              className={`Qsmd:ml-margin-base ml-margin-sm flex flex-col Qsmd:items-center items-start ${
                                !isAccountServiceAvailable &&
                                "opacity-light-opacity"
                              }`}
                            >
                              <p className="text-font-md Qsmd:text-font-md font-semibold text-text-primary pb-padding-xs flex items-center">
                                {isNaN(item.title)
                                  ? item.title
                                  : Number(item.title).toLocaleString("en-IN")}
                              </p>

                              <div className="text-font-xs text-text-secondary">
                                {item.desc.split(" ").slice(0, 3).join(" ")}
                                &nbsp;
                                <br className="hidden Qsmd:block" />
                                {item.desc.split(" ").slice(3).join(" ")}
                              </div>
                            </div>
                          </div>
                          {index === GlobalConfiguration.lengthCheckZero && (
                            <div
                              className={`flex Qsmd:block absolute z-z-index-content Qsmd:right-right-base Qsmd:top-top-half transform Qsmd:-translate-y-1/2 Qsmd:h-height-lg w-slider-items-seperator-line-width Qsmd:w-auto ml-margin-md Qsmd:ml-margin-base border-t-border Qsmd:border-t-border-base Qsmd:border-r-border border-primary-bg`}
                            ></div>
                          )}
                        </div>
                      );
                    })}
                  </div>

                  <div
                    className={` bottom-[var(--border)] right-right-base w-width-md bg-primary-nav transition-transform duration-animation-medium flex`}
                  >
                    <div
                      className={`flex flex-wrap text-center relative justify-center w-width-full lg:mb-margin-base`}
                    >
                      <div className="relative overflow-hidden w-width-full h-height-full">
                        <div
                          className="flex transition-transform duration-animation-medium ease-in-out h-height-full"
                          style={{
                            transform: `translateX(-${accActiveSlide * PaginationConfiguration.paginationBig}%)`,
                          }}
                        >
                          {accSlides.map((slideItems, slideIndex) => (
                            <div
                              key={slideIndex}
                              className="w-width-full flex-shrink-0"
                            >
                              <div
                                className={`flex flex-col Qsmd:flex-row text-center relative Qsmd:justify-center w-width-full h-height-full`}
                              >
                                {slideItems.map((item, index, array) => {
                                  const isLastItem =
                                    index ===
                                    slideItems.length -
                                      GlobalConfiguration.lengthCheckOne;
                                  const isAccountServiceAvailable =
                                    services?.includes(item.requiredService);

                                  const accountCount =
                                    item.title?.match(/\d+/)?.[
                                      GlobalConfiguration.lengthCheckZero
                                    ];
                                  const isAccountCountValid =
                                    openAccountSlider === "approve"
                                      ? Number(accountCount) >
                                        GlobalConfiguration.lengthCheckZero
                                      : true;

                                  const isCardAccountEnabled =
                                    isAccountServiceAvailable &&
                                    isAccountCountValid;

                                  return (
                                    <div
                                      key={index}
                                      className="w-width-full relative"
                                    >
                                      {/* CARD */}
                                      <div
                                        className={`bg-primary-nav flex Qsmd:flex-col flex-row flex-shrink-0 h-height-full items-center Qsmd:justify-center text-center px-padding-md Qsmd:px-padding-sm py-padding-sm Qsmd:py-padding-md transition-all duration-animation-medium relative z-z-index-base ${
                                          !isCardAccountEnabled
                                            ? "opacity-light-opacity cursor-not-allowed"
                                            : "opacity-base-opacity cursor-pointer global-hover-white"
                                        }`}
                                        onClick={() => {
                                          if (isCardAccountEnabled) {
                                            navigate(item.path);
                                          } else {
                                            navigate("/feature_not_assigned", {
                                              state: {
                                                unavailableService:
                                                  item.requiredService,
                                              },
                                            });
                                          }
                                        }}
                                      >
                                        {item.img && (
                                          <img
                                            src={item.img}
                                            alt={item.title}
                                            className="w-icon-lg h-icon-lg Qsmd:mb-margin-xs"
                                          />
                                        )}

                                        <div className="ml-margin-sm lg:ml-margin-base flex flex-col lg:items-center items-start">
                                          <p className="text-font-md font-semibold text-text-primary pb-padding-xs">
                                            {(() => {
                                              const match = item.title.match(
                                                /^(.+?) - (\d+|N\/A)(.*)$/,
                                              );
                                              if (match) {
                                                const [, label, value, suffix] =
                                                  match;
                                                if (value === "N/A")
                                                  return `${label} - N/A${suffix}`;

                                                const number = Number(value);
                                                const displayValue =
                                                  number ===
                                                  GlobalConfiguration.lengthCheckZero
                                                    ? "00"
                                                    : number <
                                                        GlobalConfiguration.panLength
                                                      ? number
                                                          .toString()
                                                          .padStart(
                                                            GlobalConfiguration.lengthCheckTwo,
                                                            "0",
                                                          )
                                                      : number.toLocaleString(
                                                          "en-IN",
                                                        );

                                                return (
                                                  <>
                                                    <div className="flex flex-row Qsmd:flex-col">
                                                      <div className="mr-1">
                                                        {label} -{" "}
                                                      </div>
                                                      <div>
                                                        {displayValue}
                                                        {suffix}
                                                      </div>
                                                    </div>
                                                  </>
                                                );
                                              }
                                              return item.title;
                                            })()}
                                          </p>

                                          {item.desc && (
                                            <p className="text-font-xs text-text-secondary lg:text-center">
                                              {item.desc}
                                            </p>
                                          )}
                                        </div>
                                      </div>

                                      {/* VERTICAL DIVIDER (only between 2 items in same slide) */}
                                      {!isLastItem && (
                                        <div className="flex Qsmd:block absolute Qsmd:top-top-half Qsmd:-translate-y-1/2 Qsmd:h-height-lg w-slider-items-seperator-line-width Qsmd:w-auto ml-margin-md Qsmd:ml-margin-base border-t-border Qsmd:border-t-border-base Qsmd:border-r-border border-primary-bg Qsmd:right-right-base z-z-index-content"></div>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <BalanceSummary type="home_dashboard" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeDashboard;
